import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { Route, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'

import ClientRecordsSearchStore from './client-records-search.store'

import SearchPanel from './SearchPanel'
import { ParentAccountPage, AccountPage, OfficePage } from '@root/ClientRecords'

class ClientRecordsSearchPage extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      clientRecordsSearchStore: new ClientRecordsSearchStore()
    })
  }

  render () {
    return (
      <DocumentTitle title='Client record search | Atheneum Partners'>
        <div className='expert-search'>
          <SearchPanel
            clientRecordsSearchStore={this.clientRecordsSearchStore}
          />
          <div className='expert-search-results'>
            <Route
              path='/client-search/parent-account/:id'
              render={props => (
                <ParentAccountPage {...props} key={props.match.params.id} />
              )}
            />
            <Route
              path='/client-search/account/:id'
              render={props => (
                <AccountPage {...props} key={props.match.params.id} />
              )}
            />
            <Route
              path='/client-search/office/:id'
              render={props => (
                <OfficePage {...props} key={props.match.params.id} />
              )}
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(observer(ClientRecordsSearchPage))
